module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-small-thumbnails-100x100-f806dd485178f805e40cce969664285b.jpg";